// extracted by mini-css-extract-plugin
export var bubble = "_3y-0";
export var container = "_3y-3";
export var contrastBorder = "_3y-4";
export var greyOut = "_3y-2";
export var initialsWrapper = "_3y-1";
export var large = "_3y-9";
export var medium = "_3y-8";
export var mediumSmall = "_3y-7";
export var mediumSmallMedium = "_3y-c";
export var micro = "_3y-5";
export var small = "_3y-6";
export var tiny = "_3y-b";
export var xTiny = "_3y-a";